import React, { useState, useEffect } from 'react';
import './style.css';
import { ChevronDown, ChevronUp } from 'lucide-react';
import DatapointInput from '../../DatapointInput/DatapointInput';
import ProjectInput from '../../ProjectInput/ProjectInput';


const HouseCharacteristicsDataSection = ({
    datapoints,
    multipleCategories = true,
    handleDatapointChange,
    handleMarkProjectCompleted,
    updatedDatapoints,
    selectedArea
}) => {
    
    const [isExpanded, setIsExpanded] = useState(multipleCategories ? false : true);

    const itemText = datapoints.type === 'projects' ? 'project' : 'item';

    useEffect(() => {
        // When the selected area changes we should set the isExpanded state to false unless the multipleCategories is false
        if (!multipleCategories) {
            setIsExpanded(true);
        } else {
            setIsExpanded(false);
        }
    }, [selectedArea]);



    return (
        <div className={`house-characteristics-data-section ${(isExpanded) ? 'expanded' : 'collapsed'}`}>
            <div
                className={`house-characteristics-data-section-header ${multipleCategories ? 'clickable' : 'single-item'}`}
                onClick={multipleCategories ? () => setIsExpanded(!isExpanded) : undefined}
            >
                <h3>{datapoints.title} ({datapoints.datapoints.length} {itemText}{datapoints.datapoints.length === 1 ? '' : 's'})</h3>
                {multipleCategories &&
                    <button
                        className="house-characteristics-data-section-header-expand-button"
                    >
                        {isExpanded ? <ChevronUp /> : <ChevronDown />}
                    </button>
                }
            </div>
            {isExpanded &&
                <div className="house-characteristics-data-section-datapoints">
                    {datapoints.datapoints.map(datapoint => {

                        const lookupKey = datapoints.type === 'projects' ? 'project_id' : 'id';
                        const isChanged = updatedDatapoints.some(updatedDatapoint => updatedDatapoint[lookupKey] === datapoint[lookupKey]);
                        console.log('isChanged:', isChanged);
                        return (
                            datapoints.type === 'projects' ? (
                                <ProjectInput
                                    key={datapoint.project_id}
                                    project={datapoint}
                                    handleMarkProjectCompleted={handleMarkProjectCompleted}
                                    isChanged={isChanged}
                                />
                            ) : (
                                <DatapointInput
                                    key={datapoint.id}
                                    datapoint={datapoint}
                                    onChange={(value) => handleDatapointChange(datapoint.id, value)}
                                    isChanged={isChanged}
                                />
                            )
                        )
                    })}
                </div>
            }
        </div>
    );
};

export default HouseCharacteristicsDataSection;